import axios from '@/utils/request'
import config from "@/config/index";

// 获取产品概况
export const getProductGeneral = (params)=>{
  return axios.request({
     url: 'v1/product/general',
     method: 'get',
     params
   })
 };
// 获取产品列表
export const getProduct = (params)=>{
 return axios.request({
    url: 'v1/product/product',
    method: 'get',
    params
  })
};
// 获取产品详情
export const getProductDetail = (id)=>{
  return axios.request({
     url: 'v1/product/product/'+id,
     method: 'get'
   })
 };
 // 新增产品
 export const createProduct = (data)=>{
  return axios.request({
     url: 'v1/product/product',
     method: 'post',
     data
   })
 };
  // 编辑产品
  export const editProduct = (id,data)=>{
    return axios.request({
       url: 'v1/product/product/'+id,
       method: 'put',
       data
     })
   };
  // 产品回收站/还原
  export const createProductRecovery = (data)=>{
    return axios.request({
       url: '/v1/product/recovery',
       method: 'post',
       data
     })
   };
  // 永久删除产品
  export const deleteProduct= (id)=>{
    return axios.request({
       url: '/v1/product/product/'+id,
       method: 'DELETE'
     })
   };
  // 批量导入商品
  export const managementImport = (data) => {
    return config.baseUrl[process.env.VUE_APP_type] + "v1/product/import";
  };
  // 商品列表导入模板
  export const downloadmanagenmentModel = (params) => {
    return axios.request({
      url: "v1/product/importTemplate",
      method: "get",
      params,
    });
  };
  // 导出产品
  export const exportProductList = (params) => {
    return axios.request({
      url: "/v1/product/export",
      method: "get",
      params,
    });
  };
  // 新增产品规格
  export const createProductSpec = (data)=>{
    return axios.request({
       url: 'v1/product/specAdd',
       method: 'post',
       data
     })
   };
// 获取产品分类列表
export const getProductCate = (params)=>{
  return axios.request({
     url: 'v1/product/category',
     method: 'get',
     params
   })
 };

 // 新增产品一级分类
export const createCateFirst = (params)=>{
  return axios.request({
     url: 'v1/product/category/create',
     method: 'get',
     params
   })
 };
 
 // 新增产品二级分类
export const createCateSecond = (data)=>{
  return axios.request({
     url: 'v1/product/category',
     method: 'post',
     data
   })
 };
 
  // 更新分类
export const updateCate = (id,data)=>{
  return axios.request({
     url: 'v1/product/category/'+id,
     method: 'put',
     data
   })
 };
   // 删除分类
export const deleteCate = (id)=>{
  return axios.request({
     url: 'v1/product/category/'+id,
     method: 'DELETE',
   })
 };

// 获取回收站产品列表
export const getRecoveryList = (params)=>{
  return axios.request({
     url: 'v1/product/recoveryList',
     method: 'get',
     params
   })
 };
 
// 获取产品类目
export const getCategoryList = ()=>{
  return axios.request({
     url: 'v1/product/categoryList',
     method: 'get'
   })
 };

 // 获取礼品列表
export const getGift = (params)=>{
  return axios.request({
     url: 'v1/gift/gift',
     method: 'get',
     params
   })
 };
 // 获取礼品SKU列表
 export const getGiftSkuList = (params)=>{
  return axios.request({
     url: 'v1/gift/sku_list',
     method: 'get',
     params
   })
 };

  // 新增礼品
  export const createGift = (data)=>{
    return axios.request({
       url: 'v1/gift/gift',
       method: 'post',
       data
     })
   };
     // 编辑礼品
  export const editGift = (id,data)=>{
    return axios.request({
       url: 'v1/gift/gift/'+id,
       method: 'put',
       data
     })
   };
     // 礼品回收站/还原
  export const createGiftRecovery = (data)=>{
    return axios.request({
       url: '/v1/gift/delAndRestore',
       method: 'post',
       data
     })
   };
  // 永久删除礼品
  export const deleteGift= (id)=>{
    return axios.request({
       url: '/v1/gift/gift/'+id,
       method: 'DELETE'
     })
   };
    // 获取礼品详情
export const getGiftDetail = (id)=>{
  return axios.request({
     url: 'v1/gift/gift/'+id,
     method: 'get'
   })
 };
 // 获取礼品分类列表
 export const getGiftCate = (params)=>{
   return axios.request({
      url: 'v1/gift/category',
      method: 'get',
      params
    })
  };
 
  // 新增礼品一级分类
 export const createGiftCate = (data)=>{
   return axios.request({
      url: 'v1/gift/category',
      method: 'post',
      data
    })
  };
  // 更新礼物分类
  export const updateGiftCate = (id,data)=>{
    return axios.request({
       url: 'v1/gift/category/'+id,
       method: 'put',
       data
     })
   };
     // 删除礼物分类
  export const deleteGiftCate = (id)=>{
    return axios.request({
       url: 'v1/gift/category/'+id,
       method: 'DELETE',
     })
   };
  
 
 // 获取回收站产品列表
 export const getGiftRecoveryList = (params)=>{
   return axios.request({
      url: 'v1/gift/recoveryList',
      method: 'get',
      params
    })
  };

/**
 * 产品批次
 */

// 获取产品批次列表
export const getProductBatch = (params)=>{
  return axios.request({
    url: 'v1/productBatch/index',
    method: 'get',
    params
  })
};
// 获取产品批次详情
export const getProductBatchMore = (params)=>{
  return axios.request({
    url: 'v1/productBatch/detail',
    method: 'get',
    params
  })
};
// 新增产品批次
export const addProductBatch = (data)=>{
  return axios.request({
    url: 'v1/productBatch/add',
    method: 'post',
    data
  })
};
// 编辑产品批次
export const editProductBatch = (data)=>{
  return axios.request({
    url: 'v1/productBatch/update',
    method: 'put',
    data
  })
};
// 删除产品批次
export const delProductBatch = (data)=>{
  return axios.request({
    url: 'v1/productBatch/delete',
    method: 'DELETE',
    data
  })
};
// 获取产品sku列表
export const getProductSkuList = (params)=>{
  return axios.request({
    url: 'v1/productBatch/skuList',
    method: 'get',
    params
  })
};

// 产品批次快照列表
export const productBatch = (params)=>{
  return axios.request({
    url: '/v1/productBatch/history',
    method: 'get',
    params
  })
};

// 产品批次快照详情
export const productBatchHistory = (params)=>{
  return axios.request({
    url: 'v1/productBatch/historyDetail',
    method: 'get',
    params
  })
};